import { render, staticRenderFns } from "./ResidenceTypeSelect.vue?vue&type=template&id=6c332cdb&"
import script from "./ResidenceTypeSelect.vue?vue&type=script&lang=js&"
export * from "./ResidenceTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports